import { render, staticRenderFns } from "./LimitStudyPlanInputComponent.vue?vue&type=template&id=009d8579&scoped=true"
import script from "./LimitStudyPlanInputComponent.vue?vue&type=script&lang=js"
export * from "./LimitStudyPlanInputComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009d8579",
  null
  
)

export default component.exports